var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generic-button",class:_vm.classes,on:{"click":_vm.onClickHandler}},[_vm._t("default",function(){return [_vm._v("Click")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }